import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { FunnelPage } from './pages/Funnel';
import { AdminPage } from './pages/Admin';
type CreativeKey = 'default' | '1br' | '2br' | '3br' | '4br' | '5br' | 'few_items';
interface AppProps {
  /** Ad size preselection. A ?creative_key= URL parameter overrides this. */
  creativeKey?: CreativeKey;
}
export function App({
  creativeKey = 'default'
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="2rit1x23ijoou">
      <Routes data-id="element-1" data-mp="2mluawsf5bxuv">
        <Route path="/" element={<FunnelPage creativeKey={creativeKey} data-id="element-3" data-mp="2mmvkesgikcah" />} data-id="element-2" data-mp="2mmcde6sej8b8" />
        <Route path="/admin" element={<AdminPage data-id="element-5" data-mp="31ayry6a7fw1e" />} data-id="element-4" data-mp="31aqeac69cmp5" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-7" data-mp="31cte1nx7pu72" />} data-id="element-6" data-mp="31bia9o3romfy" />
      </Routes>
    </BrowserRouter>;
}